import styled from 'styled-components';

export const Container = styled.div`
  max-width: 600px;

  @media ${({ theme }) => theme.device.mobile} {
    padding: 1.5rem;
    & [name~='SubmitPropertyDetails'] {
      width: 100%;
      display: flex;
      justify-content: center;
    }
    & [name~='Cancel'] {
      width: 100%;
      display: flex;
      justify-content: center;
    }
  }
  .identityVerificationReportImageTypesRadioButtonGroup,
  .identityVerificationProviderRadioButtonGroup {
    flex-direction: row;
  }
`;

export const AddressAvailabilityIndicator = styled.div`
  position: absolute;
  right: 40px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
`;

export const OwnerAddressInputContainer = styled.div`
  position: relative;
`;
